import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
      <p>
        Welcome to <strong>Kwicth</strong>. Your privacy is important to us. This
        Privacy Policy explains how we collect, use, and protect your
        information when you visit our website <strong>kwicth.in</strong> or
        make a purchase.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name, email, phone number</li>
        <li>Shipping & billing address</li>
        <li>Payment information (processed securely by Razorpay)</li>
        <li>Order details & transaction history</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To process and deliver your orders</li>
        <li>To send order updates & notifications</li>
        <li>To improve our website and customer experience</li>
        <li>To prevent fraud and ensure secure transactions</li>
      </ul>

      <h2>3. Payments & Security</h2>
      <p>
        We use <strong>Razorpay</strong> for secure online payments. We do NOT
        store any card/bank details on our servers. All payments are encrypted
        end-to-end by Razorpay.
      </p>

      <h2>4. Cookies</h2>
      <p>
        We use cookies to improve your browsing experience and remember your
        preferences.
      </p>

      <h2>5. Sharing Your Information</h2>
      <p>
        We DO NOT sell or share your personal information with any third party
        except:
      </p>
      <ul>
        <li>Delivery partners (for shipping your order)</li>
        <li>Razorpay (for secure payment processing)</li>
      </ul>

      <h2>6. Your Rights</h2>
      <ul>
        <li>You can request deletion of your data</li>
        <li>You can request correction/update of your information</li>
        <li>You can contact us anytime for account or privacy related queries</li>
      </ul>

      <h2>7. Contact Us</h2>
      <p>
        For any questions related to privacy or data protection, contact us at:
      </p>
      <p>
        <strong>Email:</strong> support@kwicth.in  
        <br />
        <strong>Instagram:</strong> @kwicth.clothes
      </p>

      <p style={{ marginTop: "40px" }}>
        <em>Last updated: {new Date().toLocaleDateString()}</em>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
